import { create } from "zustand";
import { persist } from "zustand/middleware";

interface BillingStore {
  // Modal States
  isCancelDialogOpen: boolean;

  // Modal Actions
  openCancelDialog: () => void;
  closeCancelDialog: () => void;

  // Reset
  reset: () => void;
}

const initialState = {
  isCancelDialogOpen: false,
};

export const useBillingStore = create<BillingStore>()(
  persist(
    (set) => ({
      ...initialState,

      // Modal Actions
      openCancelDialog: () => set({ isCancelDialogOpen: true }),

      closeCancelDialog: () => set({ isCancelDialogOpen: false }),

      // Reset
      reset: () => set(initialState),
    }),
    {
      name: "billing-storage",
      partialize: () => ({
        // Don't persist modal states - they should reset on page reload
      }),
    }
  )
);
